import { useIntegrations } from '~/hooks/reactQuery/queries/useIntegrations';
import { useIntegrationsSummary } from '~/hooks/reactQuery/queries/useIntegrationsSummary';
export const useIntegrationData = (param)=>{
    let { enabled, refreshOnHookMount = false } = param;
    const { integrations, isLoading: isFullLoading, isFetching: isFullFetching, refresh: refreshFull, error: fullError } = useIntegrations({
        enabled,
        refreshOnHookMount
    });
    const { integrationsSummary, isLoading: isSummaryLoading, isFetching: isSummaryFetching, error: summaryError } = useIntegrationsSummary({
        enabled: enabled && !isFullLoading && integrations == null && fullError == null,
        refreshOnHookMount
    });
    return {
        data: integrations !== null && integrations !== void 0 ? integrations : integrationsSummary,
        isLoading: integrations == null && integrationsSummary == null && (isFullLoading || isSummaryLoading),
        isFetching: isFullFetching || isSummaryFetching,
        refresh: refreshFull,
        error: fullError !== null && fullError !== void 0 ? fullError : summaryError
    };
};
